// import React from 'react'
// import { useState } from 'react';
// import { useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import { useLocation, useNavigate } from 'react-router-dom';
// import classes from "./ZipGameResultDetails.module.css";

// const ZipGameResultDetails = () => {
//     const location = useLocation();
//     const navigate = useNavigate();

//     const [leaderboard, setLeaderboard] = useState([]);
//     const [userRank, setUserRank] = useState([]);
//     const [loading,setLoading]=useState(true);

//     const { userZip } = useSelector(
//         (state) => state?.persisted?.userZipGameTokenSlice
//     );

//     const fetchLeaderboard = async () => {
//         try {
//             setLoading(true);

//             const response = await zipGameLeaderboardApi(game?.datetime, userZip?.token);

//             setLeaderboard(response?.data?.result?.leaderboard || []);
//             setUserRank(response?.data?.result?.userRank || []);
//         } catch (error) {
//             console.log(error, "error-");
//             setLeaderboard([]);
//             setUserRank([]);
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         if (location?.state?.game) {
//             fetchLeaderboard(game);
//         }
//         else {
//             navigate("/zip-game/profile");
//         }
//     }, [location]);
//     return (
//         <div>ZipGameResultDetails</div>
//     )
// }

// export default ZipGameResultDetails


import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import classes from "./ZipGameResultDetails.module.css";
import Header from "../../components/Header";
import BottomNavbarZipGame from "../../components/ZipGame/BottomNavbarZipGame";
import { zipGameLeaderboardApi } from "../../http/http";
import {
    FaArrowLeft,
    FaStopwatch,
    FaBolt,
    FaCalendarDays,
    FaTrophy,
    FaMedal,
    FaHashtag,
    FaClockRotateLeft,
    FaChevronRight,
} from "react-icons/fa6";

const ZipGameResultDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const game = location?.state?.game;

    console.log(game, 'game-');

    const [leaderboard, setLeaderboard] = useState([]);
    const [userRank, setUserRank] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errorMessage, setErrorMessage] = useState("");

    const { userZip } = useSelector(
        (state) => state?.persisted?.userZipGameTokenSlice
    );

    const getInitials = (name) => {
        if (!name) return "U";

        return name
            .trim()
            .split(" ")
            .filter(Boolean)
            .map((item) => item[0])
            .join("")
            .slice(0, 2)
            .toUpperCase();
    };

    const formatApiDate = (dateValue) => {
        if (!dateValue) return "";

        if (typeof dateValue === "string") {
            const matched = dateValue.match(/^(\d{4}-\d{2}-\d{2})/);
            if (matched?.[1]) return matched[1];
        }

        const date = new Date(dateValue);
        if (Number.isNaN(date.getTime())) return "";

        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, "0");
        const day = `${date.getDate()}`.padStart(2, "0");

        return `${year}-${month}-${day}`;
    };

    const formatDisplayDate = (dateValue) => {
        if (!dateValue) return "-";

        const date = new Date(dateValue);
        if (Number.isNaN(date.getTime())) return "-";

        return date.toLocaleString("en-US", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    const formatOnlyDate = (dateValue) => {
        if (!dateValue) return "-";

        const date = new Date(dateValue);
        if (Number.isNaN(date.getTime())) return "-";

        return date.toLocaleDateString("en-US", {
            day: "2-digit",
            month: "long",
            year: "numeric",
        });
    };

    const formatDuration = (seconds) => {
        const totalSeconds = Number(seconds) || 0;
        const mins = Math.floor(totalSeconds / 60);
        const secs = totalSeconds % 60;

        if (mins > 0) {
            return `${mins}m ${secs}s`;
        }

        return `${secs}s`;
    };

    const fetchLeaderboard = async () => {
        try {
            if (!game?.datetime || !userZip?.token) return;

            setLoading(true);
            setErrorMessage("");

            const apiDate = formatApiDate(game?.datetime);
            const response = await zipGameLeaderboardApi(apiDate, userZip?.token);

            setLeaderboard(response?.data?.result?.leaderboard || []);
            setUserRank(response?.data?.result?.userRank || []);
        } catch (error) {
            console.log(error, "error-");
            setErrorMessage("Unable to fetch game result details.");
            setLeaderboard([]);
            setUserRank([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (game) {
            fetchLeaderboard();
        } else {
            navigate("/zip-game-history");
        }
    }, [location, userZip?.token]);

    const currentUserRank = useMemo(() => {
        if (Array.isArray(userRank) && userRank.length > 0) {
            return userRank[0];
        }
        return null;
    }, [userRank]);

    const topThree = useMemo(() => {
        return leaderboard?.slice(0, 3) || [];
    }, [leaderboard]);


    const formatTime = (totalSeconds) => {
        if (totalSeconds === null || totalSeconds === undefined) return "--";
        return `${totalSeconds}s`;
    };

    const maskMsisdn = (value) => {
        const str = String(value || "");
        if (!str) return "Unknown";
        if (str.length <= 2) return str;
        return `****${str.slice(-3)}`;
    };

    return (
        <>
            <Header />

            <div className={classes.container}>
                <div className={classes.header_section}>
                    <button
                        className={classes.back_button}
                        onClick={() => navigate(-1)}
                        type="button"
                    >
                        <FaArrowLeft className={classes.back_icon} />
                    </button>

                    <p className={classes.header_title}>Game Result Details</p>
                </div>

                <div className={classes.result_hero_card}>
                    <div className={classes.hero_glow_one}></div>
                    <div className={classes.hero_glow_two}></div>

                    <div className={classes.hero_top}>
                        <div className={classes.hero_left}>
                            <p className={classes.hero_label}>Selected Match Result</p>
                            <h2 className={classes.hero_heading}>Your Zip Game Summary</h2>
                            <p className={classes.hero_subtext}>
                                Detailed result of the selected game along with leaderboard
                                rankings for the same date.
                            </p>
                        </div>

                        <div className={classes.result_status_badge}>Completed</div>
                    </div>

                    <div className={classes.primary_result_card}>
                        <div className={classes.primary_result_header}>
                            <div className={classes.result_index_icon}>
                                <FaTrophy />
                            </div>

                            <div className={classes.primary_result_texts}>
                                <p className={classes.primary_result_title}>Match Result</p>
                                <p className={classes.primary_result_subtitle}>
                                    TRX ID: {game?.game_trx_id || "-"}
                                </p>
                            </div>
                        </div>

                        <div className={classes.result_stats_grid}>
                            <div className={classes.result_stat_item}>
                                <div className={classes.result_stat_icon}>
                                    <FaStopwatch />
                                </div>
                                <div>
                                    <p className={classes.result_stat_label}>Time Taken</p>
                                    <p className={classes.result_stat_value}>
                                        {formatDuration(game?.total_time_seconds)}
                                    </p>
                                </div>
                            </div>

                            <div className={classes.result_stat_item}>
                                <div className={classes.result_stat_icon}>
                                    <FaBolt />
                                </div>
                                <div>
                                    <p className={classes.result_stat_label}>Moves</p>
                                    <p className={classes.result_stat_value}>
                                        {game?.moves ?? 0}
                                    </p>
                                </div>
                            </div>

                            <div className={classes.result_stat_item}>
                                <div className={classes.result_stat_icon}>
                                    <FaCalendarDays />
                                </div>
                                <div>
                                    <p className={classes.result_stat_label}>Played On</p>
                                    <p className={classes.result_stat_value}>
                                        {formatDisplayDate(game?.datetime)}
                                    </p>
                                </div>
                            </div>

                            <div className={classes.result_stat_item}>
                                <div className={classes.result_stat_icon}>
                                    <FaClockRotateLeft />
                                </div>
                                <div>
                                    <p className={classes.result_stat_label}>Leaderboard Date</p>
                                    <p className={classes.result_stat_value}>
                                        {formatOnlyDate(game?.datetime)}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {loading ? (
                    <div className={classes.state_card}>
                        <div className={classes.loader}></div>
                        <p className={classes.state_text}>Loading result details...</p>
                    </div>
                ) : errorMessage ? (
                    <div className={classes.state_card}>
                        <p className={classes.state_title}>Something went wrong</p>
                        <p className={classes.state_text}>{errorMessage}</p>
                        <button
                            type="button"
                            className={classes.retry_button}
                            onClick={fetchLeaderboard}
                        >
                            Retry
                        </button>
                    </div>
                ) : (
                    <>
                        <div className={classes.rank_section}>
                            <div className={classes.section_top}>
                                <p className={classes.section_title}>Your Ranking</p>
                            </div>

                            {currentUserRank ? (
                                <div className={classes.user_rank_card}>
                                    <div className={classes.user_rank_left}>
                                        <div className={classes.rank_badge}>
                                            #{currentUserRank?.user_rank || "-"}
                                        </div>

                                        <div className={classes.user_identity}>
                                            <div className={classes.user_avatar}>
                                                {currentUserRank?.image ? (
                                                    <img
                                                        src={currentUserRank?.image}
                                                        alt={currentUserRank?.name || "User"}
                                                        className={classes.user_avatar_image}
                                                    />
                                                ) : (
                                                    <span>
                                                        {getInitials(currentUserRank?.name || "User")}
                                                    </span>
                                                )}
                                            </div>

                                            <div>
                                                <p className={classes.user_name}>
                                                    {currentUserRank?.name || "You"}
                                                </p>
                                                <p className={classes.user_msisdn}>
                                                    {currentUserRank?.msisdn || "-"}
                                                </p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className={classes.user_rank_right}>
                                        <div className={classes.small_info_box}>
                                            <span>Time</span>
                                            <strong>
                                                {formatDuration(currentUserRank?.total_time_seconds)}
                                            </strong>
                                        </div>

                                        <div className={classes.small_info_box}>
                                            <span>Moves</span>
                                            <strong>{currentUserRank?.moves ?? 0}</strong>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className={classes.empty_card}>
                                    <p>Your rank is not available for this date.</p>
                                </div>
                            )}
                        </div>

                        <div className={classes.leaderboard_section}>
                            <div className={classes.section_top}>
                                <p className={classes.section_title}>Daily Leaderboard</p>
                                <span className={classes.section_pill}>
                                    {formatOnlyDate(game?.datetime)}
                                </span>
                            </div>

                            <div className={classes.leaderboard_list}>
                                {leaderboard.map((player, index) => {
                                    const isCurrentUser =
                                        String(player?.msisdn) === String(userZip?.msisdn);

                                    return (
                                        <div
                                            key={player?.game_trx_id || `${player?.msisdn}-${index}`}
                                            className={`${classes.leaderboard_item} ${isCurrentUser ? classes.first_rank : ""}`}
                                        >
                                            <div className={classes.leaderboard_left}>
                                                <div
                                                    className={`${classes.rank_badge} ${index === 0
                                                        ? classes.rank_one
                                                        : index === 1
                                                            ? classes.rank_two
                                                            : index === 2
                                                                ? classes.rank_three
                                                                : classes.rank_default
                                                        }`}
                                                >
                                                    #{player?.user_rank || index + 1}
                                                </div>

                                                <div className={classes.avatar_circle}>
                                                    {player?.image ? (
                                                        <img
                                                            src={player.image}
                                                            alt={player?.name || "User"}
                                                            className={classes.avatar_image}
                                                        />
                                                    ) : (
                                                        getInitials(player?.name)
                                                    )}
                                                </div>

                                                <div className={classes.player_info}>
                                                    <p className={classes.player_name}>
                                                        {player?.name || "User"}
                                                    </p>

                                                    <p className={classes.player_name}>
                                                        {maskMsisdn(player?.msisdn)}
                                                    </p>

                                                    <p className={classes.player_status}>
                                                        Moves: {player?.moves ?? 0}
                                                        {isCurrentUser ? " • You" : ""}
                                                    </p>
                                                </div>
                                            </div>

                                            <div className={classes.score_box}>
                                                <p className={classes.score_value}>
                                                    {formatTime(player?.total_time_seconds)}
                                                </p>
                                                <p className={classes.score_label}>time</p>
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>


                        </div>
                    </>
                )}
            </div>

            <BottomNavbarZipGame active={null} />
        </>
    );
};

export default ZipGameResultDetails;